import { FC, ReactNode } from 'react';
import Modal from '@uikit/Modal/Modal';

type IConfirmModal = {
  onConfirm: () => void;
  onCancel: () => void;
  message: string;
  dataTestId?: string;
  confirmLabel?: ReactNode;
  cancelLabel?: string;
  title?: string;
  maxWidth?: string;
  confirmFirst?: boolean;
  className?: string;
  // extra content (e.g. a required reason field) between message and buttons
  children?: ReactNode;
  confirmDisabled?: boolean;
  cancelDisabled?: boolean;
  // move the popup by dragging its header
  draggable?: boolean;
};

const ConfirmModal: FC<IConfirmModal> = ({
  onConfirm,
  onCancel,
  message,
  dataTestId,
  confirmLabel = 'Leave',
  cancelLabel = 'Cancel',
  title = 'Are you sure you want to leave?',
  maxWidth = '358px',
  confirmFirst = false,
  className,
  children,
  confirmDisabled = false,
  cancelDisabled = false,
  draggable = false,
}) => {
  const confirmButton = {
    label: confirmLabel,
    onClick: onConfirm,
    disabled: confirmDisabled,
    testId: 'confirm-leave',
  };
  const cancelButton = {
    label: cancelLabel,
    onClick: onCancel,
    disabled: cancelDisabled,
    testId: 'confirm-cancel',
  };
  const buttons = confirmFirst
    ? [confirmButton, cancelButton]
    : [cancelButton, confirmButton];

  return (
    <Modal
      title={title}
      maxWidth={maxWidth}
      className={'confirm-modal ' + (className ?? '')}
      closeClick={onCancel}
      needConfirm={false}
      closeDisabled={cancelDisabled}
      disableDrag={!draggable}
      dataTestId={dataTestId}
    >
      <div
        className="confirm-modal-body-message"
        data-test-id={`${dataTestId}-modal-body-message`}
      >
        <p>{message}</p>
      </div>

      {children}

      <div className="confirm-modal-body-buttons">
        {buttons.map((button, index) => (
          <button
            key={button.testId}
            onClick={button.onClick}
            disabled={button.disabled}
            className={
              index === 0 ? 'confirm-button-stay' : 'confirm-button-leave'
            }
            data-test-id={`${dataTestId}-${button.testId}`}
          >
            {button.label}
          </button>
        ))}
      </div>
    </Modal>
  );
};

export default ConfirmModal;
